export enum InventoryRuleStatus {
  Live = "live",
  Disabled = "disabled",
  Draft = "draft",
}
